import { useContext } from 'react'

import { TiersContext } from '../providers/TiersProvider'

export const useTiersContext = () => {
  const tiersContext = useContext(TiersContext)

  if (tiersContext === undefined) {
    throw new Error('tiersContext must be used within a TiersProvider')
  }

  return tiersContext
}
